import { Icon, icons } from '../../../generic';
import type { OnBranchChangeFn, OnSelectRepositoryFn } from './types';
import type { Repository } from '../../../../types';
import ProjectRowBase from './ProjectRowBase';
import styles from './ConnectableProjectRow.module.less';

type ConnectableProjectRowProps = {
  repo: Repository;
  selectedRepos: Repository[];
  onBranchChange: OnBranchChangeFn;
  onSelectRepository: OnSelectRepositoryFn;
};

const ConnectableProjectRow = ({
  repo,
  selectedRepos,
  onBranchChange,
  onSelectRepository,
}: ConnectableProjectRowProps) => {
  const status = (
    <span className={styles.connectionExplainer}>
      <Icon icon={icons.circleInfo} />
      <span>
        This repo has already been uploaded via the CLI. Importing will connect it to GitHub.
      </span>
    </span>
  );

  return (
    <ProjectRowBase
      repo={repo}
      selectedRepos={selectedRepos}
      onBranchChange={onBranchChange}
      onSelectRepository={onSelectRepository}
      status={status}
      rowClassName={styles.row}
    />
  );
};

export default ConnectableProjectRow;
